import { IconBrandsFacebook } from '@doltech/icons/IconBrandsFacebook';
import { IconSystemV2BlogPronunciation } from '@doltech/icons/SystemV2/IconSystemV2BlogPronunciation';
import { IconSystemV2CourseTestVocabulary } from '@doltech/icons/SystemV2/IconSystemV2CourseTestVocabulary';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';
import { ButtonGeneral } from '@doltech/ui/lib/figma/Button/ButtonGeneral/ButtonGeneral';
import { ButtonIconBlockSize } from '@doltech/ui/lib/figma/Button/ButtonIconBlockSize/ButtonIconBlockSize';
import { ButtonIconBlockStyles } from '@doltech/ui/lib/figma/Button/ButtonIconBlockStyles/ButtonIconBlockStyles';
import { DotDivider } from '@doltech/ui/lib/figma/Divider/DotDivider';
import { DolLogoIeltsSatJuniorDictationTuHoc } from '@doltech/ui/lib/figma/DolLogo/DolLogoIeltsSatJunior';
import { DolFacebookShareButton } from '@doltech/ui/lib/figma/Social/DolFacebookShareButton';
import { TextLink } from '@doltech/ui/lib/figma/TextLink/TextLink';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { flexGap } from '@doltech/utils/lib/css-style';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div`
  background: ${colorsV2.white100};
  border-bottom: 1px solid ${colorsV2.gray20};
  box-shadow: ${shadows.zIndex2};
`;

const Content = styled.div`
  padding: 10px 24px;

  display: grid;
  grid-template-columns: max-content max-content minmax(0, 1fr) minmax(0, 332px);
  gap: 16px;
`;

const TestDetail = styled.div`
  display: flex;
  align-items: center;
`;

const BlockInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const RightArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  ${flexGap(12)}
`;

interface NavbarLandingDesktopProps {
  title: string;
  type: string;
  totalQuestions: number;
  seoUrl: string;
  pageId: string;
  onClose: () => void;
  onShadowing?: () => void;
  onLearnVocab?: () => void;
  onBack?: () => void;
}

export const NavbarLandingDesktop = (props: NavbarLandingDesktopProps) => {
  const { onClose, onShadowing, onLearnVocab, title, type, totalQuestions, seoUrl, pageId } = props;

  return (
    <Main className="navbar-dictation">
      <Content>
        <ButtonIconBlockStyles
          color="neutral"
          buttonStyle="outline"
          backgroundStyle="gray"
          colorStyle="matte"
          content={
            <ButtonIconBlockSize
              size={'x-large'}
              icon={<IconSystemV2EssentialClose size={24} color="neutralPrimary" />}
            />
          }
          onClick={onClose}
        />
        <DolLogoIeltsSatJuniorDictationTuHoc hasDivider />
        <BlockInfo>
          <ResponsiveTypography.Paragraph
            className="progress-number"
            variant="semi-bold/16-24"
            color="black100"
            ellipsis={{ tooltip: true }}
          >
            {title}
          </ResponsiveTypography.Paragraph>
          <TestDetail>
            <ResponsiveTypography.Paragraph
              className="set-name"
              variant="medium/14-20"
              color="black60"
            >
              {type}
            </ResponsiveTypography.Paragraph>
            <DotDivider dotSize={3} space={6} background={colorsV2.black20} />
            <ResponsiveTypography.Paragraph
              className="set-name"
              variant="medium/14-20"
              color="black60"
            >
              {totalQuestions} câu
            </ResponsiveTypography.Paragraph>
          </TestDetail>
        </BlockInfo>
        <RightArea>
          <DolFacebookShareButton
            pageId={pageId}
            className="social-button"
            key="facebook-share"
            url={seoUrl}
          >
            <TextLink
              fontSize="medium"
              size="medium"
              color="black"
              text="Share"
              iconLeft={<IconBrandsFacebook />}
              className="text-link"
            />
          </DolFacebookShareButton>
          <ButtonGeneral
            type="secondary"
            size="large"
            iconLeft={<IconSystemV2BlogPronunciation />}
            text="Shadowing"
            onClick={onShadowing}
          />
          <ButtonGeneral
            type="secondary"
            size="large"
            iconLeft={<IconSystemV2CourseTestVocabulary />}
            text="Từ vựng"
            onClick={onLearnVocab}
          />
        </RightArea>
      </Content>
    </Main>
  );
};
